import React, { useEffect } from 'react';
import { scrollToPageElement } from 'utils/componentsCommon';


const DictionaryLetterList = ({ dictionaryEntries }) => {
    const handleClick = letter => {
        scrollToPageElement(`#${letter}`, 5);
    };

    useEffect(() => {
    }, [dictionaryEntries]);

    return <article className="dictionaryLetterList">
        { dictionaryEntries && dictionaryEntries.length > 0 &&
        <ol>
            {
                dictionaryEntries && dictionaryEntries.map((entry, index) => (
                    <li key={ entry.letter } onClick={ () => handleClick(entry.letter) }>{ entry.letter }</li>
                ))
            }
        </ol>
        }
    </article>;
};

DictionaryLetterList.defaultProps = {};
DictionaryLetterList.propTypes = {};

export default DictionaryLetterList;
